import React, { ReactElement, useEffect, useRef } from 'react';

type FormWithRefsProps = {
  submitRef: React.RefObject<HTMLButtonElement>;
  formRef: React.RefObject<HTMLFormElement>;
};

type ComponentDecorator = (
  Component: React.ComponentType<FormWithRefsProps>
) => (props: any) => ReactElement;

type Options = {
  /** Сабмит формы только если есть фокус на одном из полей */
  shouldFieldHasFocus?: boolean;
};

export const withEnterSubmit =
  (options: Options = {}): ComponentDecorator =>
  (Component) =>
  (props) => {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    const { submitRef, formRef } = useEnterSubmit(options);

    // @ts-ignore
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <Component {...props} submitRef={submitRef} formRef={formRef} />;
  };

export const useEnterSubmit = ({ shouldFieldHasFocus }: Options = {}) => {
  const submitRef = useRef<HTMLButtonElement>(null);
  const formRef = useRef<HTMLFormElement>(null);

  useEffect(() => {
    const handlePressEnter = (e: KeyboardEvent) => {
      if (e.code !== 'Enter') {
        return;
      }

      if (!formRef.current || !submitRef.current) {
        return;
      }

      if (shouldFieldHasFocus && !formRef.current.contains(document.activeElement)) {
        return;
      }

      e.preventDefault();

      submitRef.current.click();
    };

    document.addEventListener('keydown', handlePressEnter);

    return () => {
      document.removeEventListener('keydown', handlePressEnter);
    };
  }, []);

  return {
    submitRef,
    formRef,
  };
};
